import styled from "styled-components";

export const PulseIcon = styled.div`
  border-radius: 50%;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);

  height: 22px;
  width: 22px;
  align-items: center;
  display: flex;
  align-items: center;
  justify-content: center;

  transform: scale(1);
  box-shadow: 0 0 0 0 rgba(52, 172, 224, 1);
  animation: pulse 1.2s infinite;

  @keyframes pulse {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(52, 172, 224, 0.7);
    }

    70% {
      transform: scale(1);
      box-shadow: 0 0 0 10px rgba(52, 172, 224, 0);
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(52, 172, 224, 0);
    }
  }
`;
